export enum OS {
    /**
     * @en Operating System - Unknown
     * @zh 操作系统 - 未知
     */
    UNKNOWN = 'Unknown',
    /**
     * @en Operating System - iOS
     * @zh 操作系统 - iOS
     */
    IOS = 'iOS',
    /**
     * @en Operating System - Android
     * @zh 操作系统 - 安卓
     */
    ANDROID = 'Android',
    /**
     * @en Operating System - Windows
     * @zh 操作系统 - Windows
     */
    WINDOWS = 'Windows',
    /**
     * @en Operating System - Linux
     * @zh 操作系统 - Linux
     */
    LINUX = 'Linux',
    /**
     * @en Operating System - Mac OS X
     * @zh 操作系统 - Mac OS X
     */
    OSX = 'OS X',
    /**
     * @en Operating System - Huawei Open Harmony OS
     * @zh 操作系统 - 鸿蒙
     */
    OHOS = 'OHOS',
}
